import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// Per-baby postnatal observations for a consultation (KIN-1075). One row per
// foetus (PostNatalConsultationBabyObservationDTO). Used to seed the per-baby
// sections when editing and to render the read-only detail view.
export const useBabyObservations = (consultationId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    queryKey: ["postnatalBabyObservations", consultationId, tenantVal],
    queryFn: async () => {
      const axios = createAxiosInstance();
      const response = await axios.get(
        `${tenantVal}/postnatalconsultationbabyobservation/consultation/${consultationId}`
      );

      return response.data?.data ?? response.data ?? [];
    },
    enabled: !!consultationId && !!tenantVal,
  });
};
